import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PaymentContainerComponent } from './payment-container/payment-container.component';
import { PayPalPaymentComponent } from './paypal-payment/paypal-payment.component';
import { PayrixPaymentNewComponent } from './payrix-payment-new/payrix-payment.component';
import { PayrixPaymentComponent } from './payrix-payment/payrix-payment.component';
import { StripePaymentComponent } from './stripe-payment/stripe-payment.component';
// import { WorldnetPaymentComponent } from './worldnet-payment/worldnet-payment.component';

const routes: Routes = [
  {
    path: 'payrix-payment',
    component: PayrixPaymentComponent
  },
  {
    path: 'payrix-payfield',
    component: PaymentContainerComponent
  },
  {
    path: 'paypal-payment',
    component: PayPalPaymentComponent
  },
  {
    path: 'payrix-payment-field',
    component: PayrixPaymentNewComponent
  },
  {
    path: 'stripe-payment',
    component: StripePaymentComponent
  },
  // {
  //   path: 'worldnet-payment',
  //   component: WorldnetPaymentComponent
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PayrixRoutingModule { }
